import React from "react";
import Consult from "../components/consult/Consult";

const consultation = () => {
  return <Consult back />;
};

export default consultation;
